<template>
  <div class="details-contents" v-if="content.introduce">
    <div v-html="content.introduce.replace('\n', `<br/><p style='height: 0.2rem;'></p>`)"></div>
  </div>
</template>

<script>
export default {
  name: 'Contents',
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  components: {},
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.details-contents {
  width: 100%;
  height: auto;
  background: #fff;
  padding: 0.3rem;
  font-size: 0.3rem;
  color: #666;
  overflow-y: scroll;
  padding-bottom: 1.5rem;

  ::v-deep {
    img {
      display: block;
      width: 100%;
      border-radius: 0.14rem;
      height: auto !important;
      margin: 0.32rem 0;
    }
    video {
      margin: 0.32rem 0;
    }
  }
}
</style>
